module.exports = __webpack_public_path__ + "static/media/1010656.bebbc10c.jpg";